/*
 * ****************************************************************************
 * Copyright (C) 2018-2018, All rights reserved.
 * Project: chessmate
 * Modified By: rogerk
 * Created On: July 20th, 2018
 * Last Modified: July 20th, 2018
 * ****************************************************************************
 */
export const breakpoints = {
  sm: 600,
};

export default breakpoints;


// WEBPACK FOOTER //
// ./src/app/breakpoints.ts